import React from 'react';

export const FIREBASE_AUTH_DEFAULT_CONFIG = {
  firebase: {},
  isAnonymous: true,
  isReady: false,
  isSignedIn: false,
  providerId: null,
  token: null,
  user: null,
};

const FirebaseAuthContext = React.createContext(FIREBASE_AUTH_DEFAULT_CONFIG);

FirebaseAuthContext.displayName = 'FirebaseAuthContext';

export default FirebaseAuthContext;
